module.exports = __webpack_public_path__ + "static/img/06_3.e922749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250403/06_3.jpg
// module id = 3ec+
// module chunks = 0